import { Application, ApplicationBuilder } from "@fastoche/core";
import { MvcVuePlugin } from "./MvcVuePlugin";
import { GlobalApplicationContext } from "../application/GlobalApplicationContext";
/**
 * A builder to configure a hybrid Vue.js application, using the Fastoche.js module system.
 * <br>The constructor of the class is not public: you must use the static method `create`, present on the constructor.
 */
export class MvcVueApplicationBuilder extends ApplicationBuilder {
    static create(logger) {
        return new MvcVueApplicationBuilder(logger);
    }
    /**
     * Set the options for the root component of the application
     */
    root(ctor) {
        this.rootComponent = ctor;
        return this;
    }
    /**
     * @internal
     */
    appendDefaultPlugins() {
        if (!this.rootComponent) {
            throw new Error("You must set the root component of the application.");
        }
        this.plugin(MvcVuePlugin, { rootComponent: this.rootComponent });
    }
    /**
     * Start the application
     */
    async start() {
        try {
            this.appendDefaultPlugins();
            this.applyLazyActions();
            this.config.rootContainer.options.skipBaseClassChecks = true;
            const app = new Application(this.logger, this.config);
            GlobalApplicationContext.default.fastoche = app;
            return await app.start();
        }
        catch (e) {
            const appContainer = document.querySelector("#app");
            if (appContainer) {
                appContainer.removeAttribute("v-cloak");
            }
            throw e;
        }
    }
}
//# sourceMappingURL=MvcVueApplicationBuilder.js.map